import includes from 'lodash/includes'

//TODO: no idea whats up with the types here
export const getSelectedidentifiers = (
  possibleIdentifiers: any, // string[] | undefined,
  selectedIdentifiers: any //string[] | undefined
) => {
  if (typeof possibleIdentifiers?.[0] === 'string') {
    return possibleIdentifiers.filter((value: any) =>
      includes(selectedIdentifiers, value)
    )
  } else {
    //TODO: when is this an object with legend?
    return possibleIdentifiers?.filter((value: any) =>
      includes(selectedIdentifiers, value?.legend)
    )
  }
}
